import { Component, OnInit, OnDestroy, ViewChild, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Observable, from } from 'rxjs';
import { concatMap, filter, toArray, take, map } from 'rxjs/operators';
import { FacadeSesionService } from 'src/app/services/facade-sesion.service';
import { LevantamientoObraService } from 'src/app/services/levantamiento-obra.service';
import { LevantamientoObra } from 'src/app/models/entities/levantamiento-obra';
import { RutaCatalogoEnum } from 'src/app/shared/enums/ruta-catalogo.enum';
import { CatalogoService } from 'src/app/services/catalogo.service';
import { ElementoCatalogo } from 'src/app/models/entities/elemento-catalogo';
import { Obra } from 'src/app/models/entities/obra';
import { MapUtils } from 'src/app/shared/utils/map-utils';
import { AgmMap, AgmMarker } from '@agm/core';
import { ObraService } from 'src/app/services/obra.service';
import { Estado } from 'src/app/models/entities/estado';
import { ObraDTO } from 'src/app/models/dtos/obra-dto';
import { InfoWindow } from '@agm/core/services/google-maps-types';
import { Capa } from 'src/app/models/entities/capa';
import { CapaService } from 'src/app/services/capa.service';
import { SegmentoService } from 'src/app/services/segmento.service';
import { Segmento } from 'src/app/models/entities/segmento';
import { LevantamientoSeleccionadoDTO } from 'src/app/models/dtos/levantamiento-seleccionado-dto';
import { Coordenada } from 'src/app/models/entities/coordenada';
import { CapaSegmentosDTO } from 'src/app/models/dtos/capa-segmentos-dto';

@Component({
  selector: 'busqueda-obras-planeacion',
  templateUrl: './busqueda-obras-planeacion.component.html',
  styleUrls: ['./busqueda-obras-planeacion.component.scss']
})
export class BusquedaObrasPlaneacionComponent implements OnInit, OnDestroy {

  @Output() markerClick: EventEmitter<AgmMarker> = new EventEmitter<AgmMarker>();
  @ViewChild(AgmMap)
  public mapa: AgmMap;
  public buscadorForm: FormGroup = null;
  public catDireccionesAdjuntas: ElementoCatalogo[] = null;
  public catEstados: Estado[] = [];
  public obras$: Observable<LevantamientoObra[]>;
  public obrasInformacion$: Observable<ObraDTO[]>;
  public obrasLevantamiento: LevantamientoObra[] = [];
  public levantamientosObrasFiltradas: LevantamientoObra[] = [];

  public mostrarMapaObras: boolean = false;
  public catCapas: ElementoCatalogo[];
  public catSubElementos: ElementoCatalogo[];
  public catColores: ElementoCatalogo[];
  public elementosObra: LevantamientoSeleccionadoDTO;
  public map: any;

  public informacionObras: ObraDTO[] = [];
  public totalObras: number = 0;
  public totalObrasPrioritarias: number = 0;
  public totalObrasCompromiso: number = 0;
  public metaTotal: number = 0;
  public inversionTotal: number = 0;
  public obraMarkerSeleccionada: ObraDTO[] = [];

  public infoWindowActual: InfoWindow = null;
  public infoWindowAbierto: boolean = false;
  public mostrarInformacionEnInfowindow: boolean = false;

  public readonly OBRA_EN_PLANEACION: string = '1';
  public readonly OBRA_PRIORITARIA: string = '1';
  public readonly OBRA_COMPROMISO: string = '0';

  public latitudMapa: number = 0;
  public longitudMapa: number = 0;
  public zoomMapa: number = 0;
  public marker: any = {
    url: '../../../../../assets/img/iconos/marker-red.png',
    scaledSize: {
      width: 25,
      height: 25
    }
  };
  public markerSeleccionado: any = {
    url: '../../../../../assets/img/iconos/marker-blue.png',
    scaledSize: {
      width: 25,
      height: 25
    }
  };

  constructor(
    private formBuilder: FormBuilder,
    private facadeSesionService: FacadeSesionService,
    private catalogoService: CatalogoService,
    private levantamientoObraService: LevantamientoObraService,
    private mapUtils: MapUtils,
    private obraService: ObraService,
    private capaService: CapaService,
    private segmentoService: SegmentoService
  ) { }

  async ngOnInit() {
    this.facadeSesionService.breadcrumbService.actualizarBreadcrumbFuncionalidad('Búsqueda de obras en planeación');
    await this.obtenerCatalogos();
    await this.obtenerInformacionPanel();
    this.inicializarForm();
    this.obras$ = this.levantamientoObraService.findAprobados().pipe(
      map((levantamientoObra: LevantamientoObra[]) => levantamientoObra.filter(
        (obra: LevantamientoObra) => obra.keyCatTipoObra === this.OBRA_EN_PLANEACION
      ))
    )
    this.obras$.subscribe(obras => this.obrasLevantamiento = obras);
  }

  public async obtenerInformacionPanel() {
    await this.obtenerInformacionObras().then(
      (obras: ObraDTO[]) => {
        this.totalObras = this.informacionObras.length;
        this.totalObrasPrioritarias = this.informacionObras.filter((informacion: ObraDTO) => informacion.obra.keyCatTipoPrioridad === this.OBRA_PRIORITARIA).length;
        this.totalObrasCompromiso = this.informacionObras.filter((informacion: ObraDTO) => informacion.obra.keyCatTipoPrioridad === this.OBRA_COMPROMISO).length;
        for (let index = 0; index < this.informacionObras.length; index++) {
          this.metaTotal += parseFloat(this.informacionObras[index].obra.longitudTotal.toString());
          this.inversionTotal += parseFloat(this.informacionObras[index].obra.inversionTotal.toString());
        }
      }
    );
  }

  public inicializarMapa() {
    this.latitudMapa = this.mapUtils.LATITUD_PAIS_MEXICO;
    this.longitudMapa = this.mapUtils.LONGITUD_PAIS_MEXICO;
    this.zoomMapa = this.mapUtils.ZOOM_PAIS_MEXICO;
  }

  public cambioZoom(zoom: number) {
    this.zoomMapa = zoom;
  }

  public inicializarForm(): void {
    this.buscadorForm = this.formBuilder.group({
      keyEstado: new FormControl('-1'),
      keyObra: new FormControl('-1'),
      keyDireccionAdjunta: new FormControl('-1')
    });

    this.buscadorForm.get('keyEstado').valueChanges
      .pipe(
        filter((keyEstado: string) => keyEstado !== '-1')
      ).subscribe((keyEstado: string) => {
        this.mostrarMapaObras = false;
        let { lat, lng }: Estado = this.catEstados.find((estado: Estado) => estado.key === keyEstado);
        this.latitudMapa = lat;
        this.longitudMapa = lng;
        this.zoomMapa = 8;
        this.buscadorForm.get('keyObra').setValue('-1');
        this.levantamientosObrasFiltradas = this.obrasLevantamiento.filter((obras: LevantamientoObra) => obras.keyCatEstado === keyEstado);
      });

    this.buscadorForm.get('keyObra').valueChanges
      .pipe(
        filter((keyObra: string) => keyObra !== '-1')
      ).subscribe((keyObra: string) => {
        this.mostrarMapaObras = false;
        let { latitud, longitud }: LevantamientoObra = this.obrasLevantamiento.find((obra: LevantamientoObra) => obra.key === keyObra);
        this.latitudMapa = latitud;
        this.longitudMapa = longitud;
        this.zoomMapa = 11;
      });
  }

  public mapaCargado(event: any): void {
    this.mapa = event;
    this.inicializarMapa();
  }

  public async obtenerCatalogos(): Promise<any> {
    this.catDireccionesAdjuntas = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.DIRECCIONES_ADJUNTAS).pipe(take(1)).toPromise();
    this.catEstados = await this.catalogoService.obtenerCatalogo<Estado>(RutaCatalogoEnum.ESTADOS).pipe(take(1)).toPromise();
    this.catSubElementos = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.SUB_ELEMENTOS).pipe(take(1)).toPromise();
    this.catColores = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.COLORES).pipe(take(1)).toPromise();
    this.catCapas = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.CAPAS).pipe(take(1)).toPromise();
  }

  public async obtenerInformacionObras(): Promise<any> {
    let catalogoTipoObra: ElementoCatalogo[] = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.TIPOS_OBRAS).pipe(take(1)).toPromise();
    this.informacionObras = await this.obraService.findAll().pipe(
      concatMap(
        (obras: Obra[]) => from(obras).pipe(
          concatMap((obra: Obra) => this.levantamientoObraService.findByKey(obra.keyLevantamientoObra).pipe(
            take(1),
            filter((levantamientoObra: LevantamientoObra) => levantamientoObra.keyCatTipoObra === this.OBRA_EN_PLANEACION),
            concatMap((levantamientoObra: LevantamientoObra) => this.catalogoService.obtenerCatalogo<Estado>(RutaCatalogoEnum.ESTADOS).pipe(
              take(1),
              map((estados: Estado[]) => {
                let estado: Estado = estados.find((estado: Estado) => estado.key === levantamientoObra.keyCatEstado);
                return {
                  nombreEstado: estado.nombre,
                  nombreObra: levantamientoObra.nombreObra,
                  nombreTipoObra: catalogoTipoObra.find((c: ElementoCatalogo) => c.key === levantamientoObra.keyCatTipoObra).nombre,
                  nombreTramoLicitacion: levantamientoObra.nombreTramoLicitacion,
                  keyCatDireccionAdjunta: levantamientoObra.keyCatDireccionAdjunta,
                  obra
                } as ObraDTO;
              })
            ))
          )),
          toArray()
        )
      ),
      take(1)
    ).toPromise();
  }

  public obtenerInformacionObra(infoWindow: InfoWindow, obra: LevantamientoObra) {
    if (this.infoWindowActual && this.infoWindowAbierto) {
      this.infoWindowActual.close();
      this.obraMarkerSeleccionada = [];
    }
    this.obraMarkerSeleccionada = this.informacionObras.filter((datosObra: ObraDTO) => datosObra.obra.keyLevantamientoObra === obra.key);
    this.infoWindowActual = infoWindow;
    infoWindow.open();
    if (this.obraMarkerSeleccionada.length > 0) {
      this.infoWindowAbierto = true;
      this.mostrarInformacionEnInfowindow = true;
    } else {
      this.infoWindowAbierto = true;
      this.mostrarInformacionEnInfowindow = false;
    }
  }

  public async obtenerPolylines() {
    this.elementosObra = await this.capaService.findByKeyLevantamientoObra(this.obraMarkerSeleccionada[0].obra.keyLevantamientoObra).pipe(
      take(1),
      concatMap((capas: Capa[]) => from(capas)
        .pipe(
          concatMap((capa: Capa) => this.segmentoService.findByKeyCapa(capa.key).pipe(
            take(1),
            map((segmentos: Segmento[]) => {
              let elementoCoordenadaDTO: CapaSegmentosDTO = {
                capa,
                segmentos,
                nombreCapa: this.catCapas.find((e: ElementoCatalogo) => e.key === capa.keyCatCapa).nombre,
                nombreColor: this.catColores.find((e: ElementoCatalogo) => e.key === segmentos[0].keyCatColor).nombre,
              }
              return elementoCoordenadaDTO;
            })
          )),
          toArray()
        )
      ),
      map((elementoCoordenadasDTO: CapaSegmentosDTO[]) => (
        {
        ...this.obraMarkerSeleccionada[0].obra,
        elementoCoordenadasDTO
      } as unknown as LevantamientoSeleccionadoDTO
      )
      )
    ).toPromise();
    this.mostrarMapaObras = true;
  }

  public mapReady(event: any): void {
    this.map = event;
    // this.centrarTrazo();
    this.mapUtils.centrarArregloDePolylines(this.map, this.crearArregloPolylines(this.elementosObra.elementoCoordenadasDTO));
  }

  public crearArregloPolylines(arregloElementoCoordenadasDTO: CapaSegmentosDTO[]): any {
    let coordenadas: Array<Coordenada[]> = new Array<Coordenada[]>();
    arregloElementoCoordenadasDTO.forEach((elementoCoordenadasDTO) => {
      elementoCoordenadasDTO.segmentos.forEach((segmento: Segmento) => {
        coordenadas.push(segmento.coordenadas)
      });
    });
    return coordenadas.map((coordenadas: Coordenada[]) => this.crearPolyline(coordenadas))
  }

  public crearPolyline(points: Coordenada[]): any {
    return {
      googlePolylinePoints: points.map(p => ({ lat: p.latitud, lng: p.longitud }))
    };
  }

  public ngOnDestroy(): void { }

}